import { createSlice, configureStore } from '@reduxjs/toolkit';
import { useSelector as rawUseSelector, TypedUseSelectorHook } from 'react-redux';

// stateの型定義
export type State = {
  isMenuOpen: boolean
};

// 初期状態。
const initialState: State = {
  isMenuOpen: false
};

// createSliceでreducerとactionを同時に定義
const slice = createSlice({
  name: 'rootState',
  initialState,
  reducers: {
      toggleMenu: (state) => ({
        ...state,
        isMenuOpen: !state.isMenuOpen,
      }),
      closeMenu: (state) => ({
        ...state,
        isMenuOpen: false,
      }),
  },
})

// action creatorもこんな風に取り出して公開できて、dispatchでReactから利用できる
export const { toggleMenu, closeMenu } = slice.actions;

// storeを作るヘルパー複数のreducerをまとめる機能もあり
export const store = configureStore({
  reducer: slice.reducer,
});

// 複数のreducerをまとめた場合に、最終的なStateの型を取り出す
export type RootState = ReturnType<typeof store.getState>;

// 型情報付きのuseSelectorをここで宣言
export const useSelector: TypedUseSelectorHook<RootState> = rawUseSelector